import React from 'react';
import './footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="footer-section logo">
          <img src="./SSVNLOGOO.png" alt="Logo" className="logo-img" style={{marginBottom:"10px"}} />
          <br></br>
          <p className='res-info'>Sai Shanti Vidya Niketan offers exceptional early childhood education with programs for Pre-Nursery, Nursery, LKG, and UKG..</p>
          <div className="social-media">
           <a href='/'> <i className="fab fa-instagram"></i></a>
           <a href='/'> <i className="fab fa-facebook"></i></a>
            {/* <i className="fab fa-youtube"></i> */}
            
          </div>
         
          
        </div>
        <div className="footer-section useful-links">
          <h3>Get In Touch</h3>
          <ul>
            <li>Address: Sahar Sahi, WN 08, Infront of Baripada ITI, Baripad, Mayaurbhanj, Odisha-757001</li>
            <li>Call Us : +91 9437086696</li>
            <li><a href="mailto:ssvnbaripada@gmail.com" style={{color:"white"}} >E-Mail: ssvnbaripada@gmail.com </a></li>
          </ul>
        </div>
        <div className="footer-section customer-services">
          <h3 className="text-white-footer">Quick Links</h3>
          {/* <ul>
         
            <li>Home</li>
            <li>About Us</li>
            <li>Ourprograms</li>
            <li>Contact Us</li>
          </ul> */}
<ul>
         <li> <a className="btn btn-link" href="/" style={{color:'white'}}>Home</a></li>
         <li>   <a className="btn btn-link" href="/myabout">About Us</a></li>
         <li> <a className="btn btn-link" href="/Gallery">Gallery</a></li>
         <li> <a className="btn btn-link" href="/Ourprograms">Ourprograms</a></li>
         <li>  <a className="btn btn-link" href="/Contact">Contact</a></li>
          </ul>
        </div>
        <div className="footer-section location-map">
          <h3>Our Location</h3>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d1555.940064355624!2d86.73289597611617!3d21.947234733552587!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjHCsDU2JzQ0LjYiTiA4NsKwNDMnNTcuOCJF!5e0!3m2!1sen!2sin!4v1723110149581!5m2!1sen!2sin"
            width="300"
            height="200"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Location Map"
          ></iframe>
        </div>
      </footer>
      <div className="bottom-header">
      <div className="paragraph_footer">
                  <p className='foot1' >
                     © Copyright <a className='ffkgk' href='#'>
                      </a> Sai Shanti Vidya Niketan  2024  All Rights Reserved.
                      </p>
                  <p className='foott2'>Designed By <a href="https://www.excerptech.com" target="_blank" rel="noopener noreferrer" style={{color:"white"}}>EXCERPT TECHNOLOGIES PVT.LTD</a></p>
                  </div>
      </div>
    </>
  );
};

export default Footer;
